import { createContext, useContext } from "react";

import type { ModelViewerElement } from "@google/model-viewer";
import { IS_IOS, IS_SCENEVIEWER_CANDIDATE, IS_WKWEBVIEW } from "@google/model-viewer/lib/constants";
import type { ModelScene } from "@google/model-viewer/lib/three-components/ModelScene";
import { PlatformAPI } from "@shapr3d/frontend-lib";

const IS_AR_QUICKLOOK_CANDIDATE = (() => {
  if (IS_IOS) {
    if (!IS_WKWEBVIEW) {
      const tempAnchor = document.createElement("a");
      return Boolean(
        tempAnchor.relList && tempAnchor.relList.supports && tempAnchor.relList.supports("ar")
      );
    } else {
      // This is changed from the original export because if we are in a
      // WKWebView context we cannot use AR Quick Look until we have backend usdz converison
      // @see https://github.com/shapr3d/web-viewer-client/pull/52
      return PlatformAPI.getInstance().getBrowserName() === "Safari";
    }
  } else {
    return false;
  }
})();

export type ModelViewerType = ModelViewerElement & { scene: ModelScene };
export const ModelViewerContext = createContext<ModelViewerType | undefined>(undefined);

export const isARSupportedDevice = () => IS_SCENEVIEWER_CANDIDATE || IS_AR_QUICKLOOK_CANDIDATE;

export const useModelViewer = () => {
  const modelViewer = useContext(ModelViewerContext);

  if (modelViewer) {
    const scene = modelViewer[
      //eslint-disable-next-line
      //@ts-ignore
      Object.getOwnPropertySymbols(modelViewer).find((e) => e.description === "scene")
    ] as ModelScene;

    modelViewer.scene = scene;
  }

  return modelViewer;
};
